import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UnlockIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M16.1111 12H7.22222C5.99492 12 5 12.9949 5 14.2222V19.7778C5 21.0051 5.99492 22 7.22222 22H16.1111C17.3384 22 18.3333 21.0051 18.3333 19.7778V14.2222C18.3333 12.9949 17.3384 12 16.1111 12Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M8.33337 7.55556V5.33333C8.33337 3.44444 9.77782 2 11.6667 2C13.5556 2 15 3.44444 15 5.33333V9.77778"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
      />
    </BaseIcon>
  ),
);

UnlockIcon.displayName = 'UnlockIcon';
